import {useEffect, useState} from "react";
import {list as listSurveys} from "app/requests/surveys";

export default function Surveys({setSurveyID}) {
  const [surveys, setSurveys] = useState(null);

  useEffect(() => {
    listSurveys().then((data) => setSurveys(data.surveys));
  }, []);

  if(!surveys) { return; }

  return (
    <section className="container max-w-screen-md">
      <h1 className="text-center">Choose Your Adventure</h1>
      <div className="gap-6 grid my-8 md:grid-cols-3">
        {surveys.map(({color, description, icon, key, name}) => (
          <button key={key} className="border-solid border-gray hover:border-theme p-4 rounded-sm text-center" onClick={() => setSurveyID(key)} type="button">
            <div className="mx-auto p-3 rounded-sm w-12" style={{background: color}}>
              <img alt="Badge" src={icon} />
            </div>
            <div className="italic my-2">{name}</div>
            <div>{description}</div>
          </button>
        ))}
      </div>
    </section>
  );
}
